import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useApiClient } from '@/shared/api'

type TTToolTypeArgumentsView = 'fixed' | 'text' | 'checkbox' | 'number' | 'list_key_value' | 'choice'

export type TToolTypeArguments = {
  name: string
  type?: TTToolTypeArgumentsView
  description?: string
  placeholder?: string
  is_required: boolean
  default_value?: string | number | boolean
  allowed_value_types?: ('fixed_value' | 'llm_value')[]
  options?: string[]
}

export type ToolTypeWithCompany = {
  id: number
  type_name: string
  url: string | null
  required_arguments: TToolTypeArguments[]
  icon_url: string | null
  instructions: string | null
  allow_args: boolean
  company_id: number | null
}

export function useAllToolTypes() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['tool-types-all'],
    queryFn: async () => {
      return apiClient<ToolTypeWithCompany[]>('/tool-types/all')
    },
  })
}

export function useSaveToolType() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: { id?: number; data: Record<string, unknown> }) => {
      const isNew = !params.id || params.id === 0
      const url = isNew ? '/tool-types' : `/tool-types/${params.id}`
      const method = isNew ? 'POST' : 'PUT'

      return apiClient<ToolTypeWithCompany>(url, {
        method,
        body: JSON.stringify(params.data),
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tool-types-all'] })
    },
  })
}

export function useDeleteToolType() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: number) => {
      return apiClient<{ message: string }>(`/tool-types/${id}`, {
        method: 'DELETE',
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tool-types-all'] })
    },
  })
}